import { ContentNugget } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { NuggetSection } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/NuggetSection';
import { SearchFiltersGroup } from '@backrs_ui/grow-ui/src/pages/Search/components/SearchFiltersGroup';
import { SEARCH_CATEGORIES } from '@backrs_ui/grow-ui/src/pages/Search/search.filters';
import {
  SearchCategory,
  SearchParentCategory,
} from '@backrs_ui/grow-ui/src/pages/Search/search.types';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

import { Box } from '@mui/material';

type OpportunitiesSectionProps = Readonly<{
  opportunities: ContentNugget[];
  isLoading: boolean;
  selectedFilters: SearchCategory[];
  onFilterChange: (filters: SearchCategory[]) => void;
}>;

const SECTION_STRINGS = appStrings.modules.employer.opportunities;

const RESOURCE_CATEGORIES: SearchParentCategory[] = [
  {
    name: 'Filter',
    iconName: 'FilterLines',
    categories: [
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_INTERNSHIPS, label: 'Internships' },
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_JOBS, label: 'Jobs' },
    ],
    isInMoreFilters: false,
  },
];

export const OpportunitiesSection = ({
  opportunities,
  isLoading,
  selectedFilters,
  onFilterChange,
}: OpportunitiesSectionProps) => {
  const dispatch = useAppDispatch();

  const handleNuggetClick = (nugget: ContentNugget) => {
    dispatch(setCurrentDialogNugget(nugget));
  };

  const handleFilterChange = (filters: SearchCategory[]) => {
    onFilterChange(filters);
  };

  return (
    <Box>
      <NuggetSection
        title={SECTION_STRINGS.title}
        nuggets={opportunities}
        onNuggetClick={handleNuggetClick}
        loading={isLoading}
        headerButton={
          <SearchFiltersGroup
            selectedItems={selectedFilters}
            setSelectedItems={handleFilterChange}
            categories={RESOURCE_CATEGORIES}
          />
        }
      />
    </Box>
  );
};
